export default {
  'Line':'fe-line',
  'Histogram': 'fe-histogram',
  'Bar': 'fe-bar',
  'Pie': 'fe-pie',
  'Ring': 'fe-ring',
  'Radar': 'fe-radar',
  'Scatter': 'fe-scatter',
  'Map': 'fe-map'
}



// WEBPACK FOOTER //
// ./src/components/FromBase/charts/index.js